import React, {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
import {CloseIcon} from 'shared/icons';
import {AuthorizedLayoutNavigation} from './AuthorizedLayoutNavigation';

interface AuthorizedLayoutMobileMenuProps {
	onClose: () => void;
	onLogout: () => void;
}

export function AuthorizedLayoutMobileMenu({onClose, onLogout}: AuthorizedLayoutMobileMenuProps): React.ReactElement {
	const closeButtonRef = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		closeButtonRef.current?.focus();
	}, []);

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Escape') {
				onClose();
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [onClose]);

	useEffect(() => {
		const previousOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = previousOverflow;
		};
	}, []);

	return createPortal(
		<div role="dialog" aria-modal="true" aria-label="Меню" className="fixed inset-0 z-50 flex flex-col bg-white sm:hidden">
			<div className="flex h-14 shrink-0 items-center border-b border-black/10 px-6">
				<button
					ref={closeButtonRef}
					type="button"
					onClick={onClose}
					className="inline-flex h-5 w-5 items-center justify-center text-black"
					aria-label="Закрыть меню"
				>
					<CloseIcon className="h-5 w-5" />
				</button>
			</div>
			<div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
				<AuthorizedLayoutNavigation
					variant="sheet"
					onNavigate={onClose}
					onLogout={() => {
						onClose();
						onLogout();
					}}
				/>
			</div>
		</div>,
		document.body,
	);
}
